import * as constants from '../config/constants';
import * as THREE from 'three';
import axios from 'axios';

export const updateConfiguration = () => {
  return (dispatch, getState) => {
    const {
      parameters,
      parameters: { configuration, rack, uxPath, width, length, count }
    } = getState();

    const multiplier = 12;
    const w = width * multiplier + 'pt';
    const l = length * multiplier + 'pt';

    axios
      .post('/api/configurator', {
        count: null,
        width: width * 12,
        length: length * 12,
        configuration,
        rack
      })
      .then((res) => {
        dispatch({
          type: constants.CONFIGURATION_RESULTS,
          data: res.data
        });
      })
      .catch((err) => {
        console.log('Error: ', err);
      });
  };
};

export const parameterWidth = (data) => {
  return (dispatch, getState) => {
    dispatch({
      type: constants.PARAMETER_WIDTH,
      data
    });
    dispatch(updateConfiguration(dispatch, getState));
  };
};

export const undoWidth = (data) => {
  return (dispatch, getState) => {
    dispatch({
      type: constants.UNDO_WIDTH,
      data
    });
    dispatch(updateConfiguration(dispatch, getState));
  };
};

export const undoLength = (data) => {
  return (dispatch, getState) => {
    dispatch({
      type: constants.UNDO_LENGTH,
      data
    });
    dispatch(updateConfiguration(dispatch, getState));
  };
};

export const parameterLength = (data) => {
  return (dispatch, getState) => {
    dispatch({
      type: constants.PARAMETER_LENGTH,
      data
    });
    dispatch(updateConfiguration(dispatch, getState));
  };
};

export const parameterDimensions = (width, length) => {
  return (dispatch, getState) => {
    dispatch({
      type: constants.PARAMETER_DIMENSIONS,
      data: { width, length }
    });
    dispatch(updateConfiguration(dispatch, getState));
  };
};

export const parameterBikeCount = (data) => {
  return (dispatch, getState) => {
    dispatch({
      type: constants.PARAMETER_BIKE_COUNT,
      data
    });
    dispatch(updateConfiguration(dispatch, getState));
  };
};

export const parameterRows = (data) => {
  return {
    type: constants.PARAMETER_ROWS,
    data
  };
};

export const parameterColumns = (data) => {
  return {
    type: constants.PARAMETER_COLUMNS,
    data
  };
};

export const parameterConfiguration = (data) => {
  return (dispatch, getState) => {
    const {
      parameters: { rack }
    } = getState();
    if (data === 'Balanced') {
      if (rack === 'hybrid' || rack === 'let the experts decide') {
        dispatch(parameterRack('two-tier'));
      }
    }
    if (data === 'Rider Friendly') {
      dispatch(parameterRack(''));
    } else if (rack === '') {
      dispatch(parameterRack('two-tier'));
    }

    dispatch({
      type: constants.PARAMETER_CONFIGURATION,
      data
    });
    dispatch(updateConfiguration(dispatch, getState));
  };
};

export const parameterRack = (data) => {
  return (dispatch, getState) => {
    dispatch({
      type: constants.PARAMETER_RACK,
      data
    });
    dispatch(updateConfiguration(dispatch, getState));
  };
};

export const toggleRenderBikes = () => {
  return (dispatch, getState) => {
    const { renderBikes } = getState().parameters;
    dispatch({
      type: constants.RENDER_BIKES,
      data: !renderBikes
    });
  };
};

export const referencePoints = (bbox) => {
  return (dispatch, getState) => {
    const { rows, columns } = getState().parameters;
    const { min, max } = bbox;
    const xSpan = max.x - min.x;
    const zSpan = max.z - min.z;
    const zMargin = zSpan * 0.8;
    let i = 0;

    const positions = [];
    while (i < rows) {
      let j = 0;
      while (j < columns) {
        positions.push(new THREE.Vector3(xSpan * i, 0, (zSpan + zMargin) * j));
        j++;
      }
      i++;
    }

    dispatch({
      type: constants.REFERENCE_POINTS,
      data: positions
    });
  };
};

export const savePdfOn = () => {
  return (dispatch, getState) => {
    if (!getState().parameters.savePdf) {
      dispatch({ type: constants.SAVE_PDF_ON });
    } else {
      dispatch({ type: 'IGNORED_PDF_SAVE_IN_PROGRESS' });
    }
  };
};
export const savePdfOff = () => {
  return { type: constants.SAVE_PDF_OFF };
};



// WEBPACK FOOTER //
// ./src/actions/parameters.js